import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import Raven from 'raven-js';
export default Loadable({
  loader: () => import(
  // Use `onboarding-tours` as chunk name to align with `AsyncOnboardingTour`.
  /* webpackChunkName: "onboarding-tours" */
  './OnboardingTourModals').then(mod => mod.OnboardingTourModals),
  LoadingComponent: () => null,
  ErrorComponent: ({
    error
  }) => {
    Raven.captureException(error);
    console.error(error);
    return null;
  }
});